/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const resourcePatchRequestSchema = z.object({
  employmentType: z.enum(['EMPLOYEE', 'CONTRACTOR', 'PARTNER', 'ON_DEMAND', 'AI_AGENT']).nullish(),
  isActive: z.boolean().nullish(),
  name: z.string().nullish(),
  type: z.enum(['RESOURCE', 'PLACEHOLDER']).nullish(),
});
